/* -- Generated File: Do Not Edit ------------------------------------------ */
export const fontFamily = {
  fontFamilySans:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamilyMono: 'monospace, monospace',
};

export default fontFamily;
/* -- Generated File: Do Not Edit ------------------------------------------ */
